export const findDates = (zoom: string) => {
  //gets the current date
  const currentTime = new Date();

  //function to get a previous month and account for differing days of each month
  const changeMonths = (date: Date, months: number) => {
    let tempDate = new Date(date);
    const month = (date.getMonth() + months) % 12;
    //create a new Date object that gets the last day of the desired month
    const last = new Date(date.getFullYear(), month + 1, 0);

    //compare dates and set appropriately
    if (date.getDate() <= last.getDate()) {
      tempDate.setMonth(month);
    } else {
      tempDate.setMonth(month, last.getDate());
    }

    return tempDate;
  };

  let returnedDates: string[] = [];
  returnedDates.push(currentTime.toDateString());

  if(zoom === "day") {
    const times = [4, 8, 12, 16, 20, 24]
    times.forEach((hrs) => {
        returnedDates.push(new Date(currentTime.getTime() - hrs * 60 * 60 * 1000).toDateString());
    });
    //returnedDates.push(dayAgo);
  } else if (zoom === "week") {
    for(let i = 1; i < 8; i++) {
        returnedDates.push(new Date(currentTime.getTime() - i * 24 * 60 * 60 * 1000).toDateString());
    }
    //returnedDates.push(weekAgo);
  } else if (zoom === "month") {
    for(let i = 1; i < 5; i++) {
        returnedDates.push(new Date(currentTime.getTime() - i * 7 * 24 * 60 * 60 * 1000).toDateString());
    }
  } else if (zoom === "half-year") {
    for(let i = 1; i < 6; i++) {
        returnedDates.push(changeMonths(currentTime, -i).toDateString());
    }
  } else if (zoom === "year") {
    for(let i = 1; i < 13; i++) {
        returnedDates.push(changeMonths(currentTime, -i).toDateString());
    }
  }

  return returnedDates;
};
